import { useEffect, useRef } from 'react'
import { useLocation } from 'react-router-dom'

import { trackPageview } from '@/utils/analytics'

/**
 * Hook for manual pageview tracking on route changes
 * Ensures pageviews fire exactly once per navigation (no duplicates from rerenders)
 */
export function usePageviewTracking(): void {
  const location = useLocation()
  const previousPath = useRef<string | null>(null)

  useEffect(() => {
    const currentPath = location.pathname + location.search

    // Only track if path actually changed (avoid duplicate fires)
    if (previousPath.current !== currentPath) {
      trackPageview(window.location.href)
      previousPath.current = currentPath
    }
  }, [location.pathname, location.search])
}
